import {Actions, createEffect, ofType} from '@ngrx/effects';
import {AffiliateService} from '@services/affiliate/affiliate.service';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {of} from 'rxjs';
import {
  fetchTopDownlines,
  fetchTopDownlinesFailure, fetchTopDownlinesSuccess,
  fetchTopPromotions,
  fetchTopPromotionsToolsFailure,
  fetchTopPromotionsToolsSuccess
} from './top-listing.actions';
import {TopListingsService} from '@services/top-listings/top-listings.service';

@Injectable()
export class TopListingEffects {

  constructor(
    private actions$: Actions,
    private topListingService: TopListingsService
  ) {
  }

  getTopPromotionsTools$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fetchTopPromotions),
        mergeMap(action =>
          this.topListingService.getTopPromotionTools(action.payload)
            .pipe(
              map(data => {
                return fetchTopPromotionsToolsSuccess({data});
              }),
              catchError(error => {
                return of(fetchTopPromotionsToolsFailure({error}));
              })
            )
        )
      );
  });

  getTopDownlines$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fetchTopDownlines),
        mergeMap(action =>
          this.topListingService.getTopDownlines(action.payload)
            .pipe(
              map(data => {
                return fetchTopDownlinesSuccess({data});
              }),
              catchError(error => {
                return of(fetchTopDownlinesFailure({error}));
              })
            )
        )
      );
  });

}
